import moment from 'moment';
import {LANGUAGES} from '../constants/dia';

export default class dateHelper {

  static parseDate(s, options = null) {
    return moment(s, options);
  }

  static formatToApi(s, options = null) {
    return this.parseDate(s, options).format('Y-M-D');
  }

  static getEpochFromString(string, options) {
    return this.parseDate(string, options).valueOf();
  }

  static formatTimestamp(s, locale) {
    if (!locale) {
      locale = LANGUAGES[0];
    }
    // TODO fromNow if less than 1 month ago?
    return moment(s, 'X').locale(locale).format('LL');
  }

  static formatDate(s, locale) {
    if (!locale) {
      locale = LANGUAGES[0];
    }
    // TODO fromNow if less than 1 month ago?
    return moment(s, 'Y-M-D').locale(locale).format('LL');
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/dateHelper.js
 **/